"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.GQL_FETCH_BOOK = exports.GQL_FETCH_BOOKS = undefined;

var _templateObject = _taggedTemplateLiteral(["\n\tquery books {\n\t\tbooks(page: 0, pagesize: 99) {\n\t\t\tbooks {\n\t\t\t\tid\n\t\t\t\ttitle\n\t\t\t\timage {\n\t\t\t\t\t", "\n\t\t\t\t}\n\t\t\t\tsubtitle\n\t\t\t\tembedCode\n\t\t\t}\n\t\t}\n\t}\n"], ["\n\tquery books {\n\t\tbooks(page: 0, pagesize: 99) {\n\t\t\tbooks {\n\t\t\t\tid\n\t\t\t\ttitle\n\t\t\t\timage {\n\t\t\t\t\t", "\n\t\t\t\t}\n\t\t\t\tsubtitle\n\t\t\t\tembedCode\n\t\t\t}\n\t\t}\n\t}\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n\tquery book($id: ID!) {\n\t\tbook(id: $id) {\n\t\t\tid\n\t\t\ttitle\n\t\t\timage {\n\t\t\t\t", "\n\t\t\t}\n\t\t\tsubtitle\n\t\t\tembedCode\n\t\t}\n\t}\n"], ["\n\tquery book($id: ID!) {\n\t\tbook(id: $id) {\n\t\t\tid\n\t\t\ttitle\n\t\t\timage {\n\t\t\t\t", "\n\t\t\t}\n\t\t\tsubtitle\n\t\t\tembedCode\n\t\t}\n\t}\n"]);

var _graphqlTag = require("graphql-tag");

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _graphQlHelpers = require("@manakin/app-core/graphQlHelpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var GQL_FETCH_BOOKS = exports.GQL_FETCH_BOOKS = (0, _graphqlTag2.default)(_templateObject, _graphQlHelpers.appAssetNoThumbnail);

var GQL_FETCH_BOOK = exports.GQL_FETCH_BOOK = (0, _graphqlTag2.default)(_templateObject2, _graphQlHelpers.appAssetNoThumbnail);